export default __webpack_public_path__ + "static/media/stopwatch.e70d8fcd.svg";